/**
 * 职业病
 */

import {
  get,
  post,
  put,
  del
} from '@/util/request'
import download from "@/util/download";

/**
 * 根据Id查询
 * @param {*} Id
 * @returns
 */
export const SelectOccupationDiseaseById = (Id) => {
  return get('/api/app/OccupationDisease?CurrentId=' + Id);
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddOccupationDisease = (data) => {
  return post('/api/app/OccupationDisease', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyOccupationDisease = (data) => {
  return put('/api/app/OccupationDisease', data, {});
}

/**
 * 分页获取
 * @param {*} data
 * @returns
 */
export const GetDataOccupationDiseaseList = (data) => {
  return post('/api/app/OccupationDisease/list', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteOccupationDisease = (id) => {
  return del('/api/app/OccupationDisease/' + id, {}, {});
}

/**
 * 导出Excel
 * @param {*} id
 * @returns
 */
 export const ExportOccupationDisease = (data) => {
  let defaluturl = `/api/app/OccupationDisease/exportExcelFile`;
  let fileName = "职业病"
  return download(fileName, defaluturl, data);
}